var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(153, 0, 204)",
    d: "M12 2C8.7 2 6 4.7 6 8v34.418C6 45.594 8.832 48 12 48h32v-2H12c-2.16 0-4-1.621-4-3.582S9.8 39 12 39h32V2Zm0 2h30v33H12c-1.492 0-2.906.54-4 1.418V8c0-2.219 1.781-4 4-4m3 5c-1.094 0-2 .906-2 2v4c0 1.094.906 2 2 2h21c1.094 0 2-.906 2-2v-4c0-1.094-.906-2-2-2Zm0 2h21v4H15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.11bae1290ce5b0eeab01f650e05a47f7.svg";
export { ForwardRef as ReactComponent };